import { render, staticRenderFns } from "./baoxiuApply.vue?vue&type=template&id=2035b7d8&scoped=true"
import script from "./baoxiuApply.vue?vue&type=script&lang=js"
export * from "./baoxiuApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035b7d8",
  null
  
)

export default component.exports